import { wrapRequest } from "./nav";
const imageLibApiUrl = import.meta.env.VITE_IMAGELIB_API_URL;
const assetNodeslsUrl = import.meta.env.VITE_ASSETS_NODESLS_NEW_URL;

export const doPostOne = wrapRequest(({ specs }) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/vnd.pgrst.object+json",
      Prefer: "return=representation",
    },
    body: JSON.stringify({ specs }),
  };
  return fetch(`${imageLibApiUrl}/rpc/builder_session_create`, requestOptions);
});

export const doFetchOne = wrapRequest(({ id }) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" },
  };
  return fetch(`${imageLibApiUrl}/builder_session?id=eq.${id}`, requestOptions);
});

export const doFetchByDesignProjectId = wrapRequest(({ designProjectId }) => {
  const requestOptions = {
    method: "GET",
    headers: { "Content-type": "application/json" },
  };
  return fetch(
    `${imageLibApiUrl}/builder_session?product_data->>design_project_id=eq.${designProjectId}&select=*,builder_session_item(id,thumbnail_url,order_count)&builder_session_item.order=order_count.asc`,
    requestOptions
  );
});

export const doPatchOne = wrapRequest(({ sessionId, property }) => {
  const requestOptions = {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/vnd.pgrst.object+json",
      Prefer: "return=representation",
    },
    body: JSON.stringify({ ...property }),
  };
  return fetch(
    `${imageLibApiUrl}/builder_session?id=eq.${sessionId}`,
    requestOptions
  );
});

export const doFetchList = wrapRequest(({ sku, guestId, userId }) => {
  const requestOptions = {
    method: "GET",
    headers: {
      "Content-type": "application/json",
    },
  };

  const params = {};
  if (sku) params["quote_data->>sku"] = `eq.${sku}`;
  if (guestId) params["user_data->>guest_id"] = `eq.${guestId}`;
  if (userId) params["user_data->>customer_id"] = `eq.${userId}`;

  const qs = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");

  return fetch(
    `${imageLibApiUrl}/builder_session?${qs}&select=*,builder_session_item(builder_session_id,thumbnail_url)`,
    requestOptions
  );
});
export const doDeleteItem = wrapRequest((sessionId) => {
  const requestOptions = {
    method: "DELETE",
    headers: {
      "Content-type": "application/json",
      Prefer: "return=representation",
    },
  };

  return fetch(
    `${imageLibApiUrl}/builder_session?id=eq.${sessionId}`,
    requestOptions
  );
});

export const doConvertDesignerToLegacy = wrapRequest(
  ({ designerProject, extraProperty }) => {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        design_project: designerProject,
        extra_property: extraProperty,
      }),
    };
    return fetch(
      `${assetNodeslsUrl}/sync-design-project-to-builder-session`,
      requestOptions
    );
  }
);
